// Formats any date-ish value as dd-mm-yyyy for display across the app.
// Returns an empty string for missing/invalid input so it's safe to use inline.
export default function formatDate(value) {
    if (!value) return "";

    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
        const [y, m, dayVal] = value.trim().split('-');
        return `${dayVal.padStart(2, "0")}-${m.padStart(2, "0")}-${y}`;
    }

    const d = new Date(value);
    if (isNaN(d.getTime())) return "";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
}

// Same as above but also appends the time, e.g. 14-09-2026 10:30 AM
export function formatDateTime(value) {
    if (!value) return "";

    const d = new Date(value);
    if (isNaN(d.getTime())) return "";

    const datePart = formatDate(d);
    const timePart = d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });

    return `${datePart} ${timePart}`;
}

// yyyy-mm-dd, the format native <input type="date"> needs
export function toInputDate(value) {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
        return value.trim();
    }
    const d = value ? new Date(value) : new Date();
    if (isNaN(d.getTime())) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
}
